import React from "react";
import ContactCard from "../components/ContactCard";
import MapsLocation from "../components/MapsLocation";
import FaqAccordion from "../components/FaqAccordion";
import { FaClock, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import Stats from "../components/Stats";
import "../Styles/ContactUs.css";

const ContactUs = () => {
  return (
    <div>
      <div className="contact-header">
        <h2>
          <span>Get in Touch </span>
        </h2>
        <p>Book an Appointment to treat your teeth right now.</p>
      </div>
      <div className="contact-container">
        <div className="left-panel">
          <MapsLocation
            title="Dhotrad's Sunny Dental and Orthodontic Clinic Location"
            iframeSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3847.5139098466802!2d75.1102485!3d15.3486295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb8d720f88e9e91%3A0x899edfd6bd69424b!2sDhotrad's%20Sunny%20Dental%20and%20Orthodontic%20Clinic!5e0!3m2!1sen!2sin!4v1769931116406!5m2!1sen!2sin"
            addressText="Dhotrad's Sunny Dental and Orthodontic Clinic"
          />
          <MapsLocation
            title="Dhotrad Sunny Dental Clinic Location"
            iframeSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3847.444357854446!2d75.10311709999999!3d15.352402500000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb8d6b93aaaaaab%3A0xb3a404aa08d22f65!2sDhotrad's%20Sunny%20Dental%20Clinic%20Invisalign%20Aligners%20and%20Braces!5e0!3m2!1sen!2sin!4v1769937753081!5m2!1sen!2sin"
            addressText="Dhotrad's Sunny Dental Clinic – Invisalign, Aligners & Braces"
          />

          <ContactCard
            icon={FaClock}
            heading="Office Timings"
            subtext={`Monday to Saturday 9:30 am to 8:30 PM \nSunday 9:30 am to 2:30 pm`}
          />
          <ContactCard
            icon={FaMapMarkerAlt}
            heading="Email Address"
            subtext="dhotraddental@gmail.com"
          />
          <ContactCard
            icon={FaPhoneAlt}
            heading="Phone Number"
            subtext="+91 9343109693"
          />
        </div>

        <div className="right-panel">
          <Stats />
        </div>
      </div>
      <FaqAccordion />
    </div>
  );
};

export default ContactUs;
